import React, {useEffect, useState} from 'react';
import {MenuItemContainer} from '../system/menu';
import PulsoidClient, {PremiumInfo} from '../PulsoidClient';
import {Loader} from '../system/Loader/Loader';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Action} from '../system/buttons';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {FULL_STORY_CONFIGURATION} from '../system/FeatureDisabler';
import JotFormEmbed from '../utils/JotFormEmbed';

const forceShowForm = () => window.location.href.includes('test=true');

export const CancelSubscription = ({}) => {
  async function cancelSubscription(client) {
    try {
      let result = await client.cancelSubscription();
      let grantMessage = '';
      if (result.grantedPremiumExpiredAt) {
        grantMessage = `Remaining BRO plan period is granted as a trial.`;
      }
      toast.info('Your subscription has been canceled.' + grantMessage);
      setAfterCancel(true);
    } catch (e) {
      if (forceShowForm()) {
        toast.info('Your subscription has been canceled.');
        setAfterCancel(true);
      } else {
        if (
          (e as any)?.details?.data &&
          (e as any).details.data.reason === 'SubscriptionIsInInitiatedState'
        ) {
          toast.warn(
            'Your subscription is not confirmed by the payment provider. Please try again in 10-15 minutes.'
          );
        } else {
          toast.warn('Something went wrong, try again.');
        }
      }
    }
  }

  const client = new PulsoidClient();

  const [premiumInfo, setPremiumInfo] = useState<PremiumInfo>();
  const [userInfo, setUserInfo] = useState<any>();
  const [afterCancel, setAfterCancel] = useState<boolean>(false);

  useEffect(() => {
    client.getPremiumInfo().then((res) => setPremiumInfo(res));
    client.getUserInfo().then((res) => setUserInfo(res));
  }, []);

  let component = (
    <Loader loading={true} description={'Loading information about premium.'} />
  );

  if (afterCancel) {
    component = (
      <Row>
        <Col>
          <Row className={'p-1'}>
            Your subscription has been canceled. Remaining BRO plan period is
            granted as a trial.
          </Row>
        </Col>
      </Row>
    );
  } else {
    if (premiumInfo) {
      if (premiumInfo.isPremium || forceShowForm) {
        if (premiumInfo.isLifetime) {
          component = (
            <Row>
              <Col>
                <Row className={'p-1'}>
                  It appears that you are currently Lifetime BRO plan. Please
                  note that cancelling the lifetime subscription is not
                  supported.
                </Row>
                <Row className={'p-1'}>
                  If you think this is an error contact at&nbsp;
                  <a href={'https://pulsoid.net/contact'}>
                    {' '}
                    support@pulsoid.net
                  </a>
                  .
                </Row>
              </Col>
            </Row>
          );
        } else if (userInfo && (premiumInfo.isSubscribed || forceShowForm())) {
          component = (
            // <Row>
            //   <JotFormEmbed
            //     email={userInfo.email}
            //     formURL={'https://form.jotform.com/242252449506355'}
            //     onSubmit={() => {
            //       cancelSubscription(client);
            //       console.log('form has been submitted');
            //     }}
            //   />
            // </Row>
            <Row>
              <Col>
                <Row className={'p-1'}>
                  After cancellation remaining BRO plan will be granted as
                  trial.
                </Row>
                <Row className={'p-1'}>
                  <Action onClick={() => cancelSubscription(client)}>
                    Cancel BRO plan subscription
                  </Action>
                </Row>
              </Col>
            </Row>
          );
        } else {
          component = (
            <Row>
              <Col>
                <Row className={'p-1'}>
                  It appears that you are currently on a trial period for the
                  BRO plan. Please note that it is not possible to cancel the
                  trial at this time.
                </Row>
                <Row className={'p-1'}>
                  If you think this is an error contact at&nbsp;
                  <a href={'https://pulsoid.net/contact'}>
                    {' '}
                    support@pulsoid.net
                  </a>
                  .
                </Row>
              </Col>
            </Row>
          );
        }
      } else {
        component = (
          <Row>
            <Col>
              <Row className={'p-1'}>
                We couldn't any find subscription associated with current
                account.
              </Row>
              <Row className={'p-1'}>
                If you think this is an error contact at&nbsp;
                <a href={'https://pulsoid.net/contact'}> support@pulsoid.net</a>
                .
              </Row>
            </Col>
          </Row>
        );
      }
    }
  }

  return (
    <MenuItemContainer title={'Cancel subscription'}>
      <ToastContainer />
      <Row style={{borderBottom: '1px solid rgb(238, 238, 238)'}}>
        <h2> Cancel subscription</h2>
      </Row>
      {component}
    </MenuItemContainer>
  );
};
